// Manage one or more interactive tab groups on the page.

function onTabClicked(_event: MouseEvent) {
  const activeTab: HTMLButtonElement = this;
  const tabGroup = activeTab.dataset.tabGroup;
  const tabId = activeTab.dataset.tabId;
  const activePanel = document.querySelector(`.tabs--tabpanel[data-tab-group=${tabGroup}][data-tab-id=${tabId}]`);

  const groupTabs = [...document.querySelectorAll(`button.tabs--tab[data-tab-group=${tabGroup}]`)] as HTMLButtonElement[];
  const groupPanels = [...document.querySelectorAll(`div.tabs--tabpanel[data-tab-group=${tabGroup}]`)] as HTMLDivElement[];

  groupTabs.forEach((tab) => {
    tab.setAttribute('aria-selected', tab === activeTab ? 'true' : 'false');
  });

  groupPanels.forEach((panel) => {
    if (panel === activePanel) {
      panel.classList.add('active');
    } else {
      panel.classList.remove('active');
    }
  });
}

function addTabClickHandlers() {
  const allTabs = [...document.querySelectorAll('button.tabs--tab')] as HTMLButtonElement[];

  allTabs.forEach((tab) => {
    tab.addEventListener('click', onTabClicked);
  });
}

// Run this with <script defer> so the following initialises during page loading.
addTabClickHandlers();
